<template>
  <DragDialog
    title="查看/设置缩略图"
    :width="320"
    :visible.sync="visible"
    :footerBtn="[]"
    :cancel="cancel">
    <div class="screenshot-box">
      <img
        v-if="imgSrc"
        :src="imgSrc" />
      <div
        class="tip-box"
        v-else>
        <div class="text-box">暂无缩略图，点击下方按钮生成缩略图</div>
      </div>
    </div>
    <div class="common-button-box">
      <el-button
        class="primary-btn primary-ang-btn"
        size="small"
        @click="updateThumbnail">
        以当前视角生成缩略图
      </el-button>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from '@/components/CustomDragDialog.vue'

import { getToken } from '@/utils/generalMethods'

import {
  uploadPublicElemThumbnailService,
  uploadPrivateElemThumbnailService
} from '@/service/interface'

export default {
  data() {
    return { imgSrc: '' }
  },
  props: {
    visible: Boolean,
    elemInfo: Object,
    closeDialog: Function
  },
  components: { DragDialog },
  methods: {
    async updateThumbnail() {
      const BlackHole3D = window.BlackHole3D

      let imgSrc = BlackHole3D.getScreenSnapshot()
      let base64Image = imgSrc.replace('data:image/png;base64,', '')

      const blob = this.base64ToBlob(base64Image, 'image/png')
      let fileName = 'custom.png'
      const fileInfo = this.blobToFile(blob, fileName)
      const formData = new FormData()
      let { elemType, dataSetId } = this.$route.query
      formData.append('FileName', fileName)
      formData.append('FileSize', fileInfo.size)
      formData.append('DataSetId', dataSetId)
      formData.append('FileInfo', fileInfo)

      if (elemType === 'PublicElem') {
        uploadPublicElemThumbnailService(formData).then(response => {
          if (response.isSuccess) {
            this.imgSrc = imgSrc
            this.$message.success('更改缩略图成功')
          } else {
            this.$message.error(response.errMsg)
          }
        })
      } else {
        uploadPrivateElemThumbnailService(formData).then(response => {
          if (response.isSuccess) {
            this.imgSrc = imgSrc
            this.$message.success('更改缩略图成功')
          } else {
            this.$message.error(response.errMsg)
          }
        })
      }
    },
    getHeaders() {
      let token = getToken()
      let headers = {
        Authorization: token
      }
      return headers
    },
    cancel() {
      this.closeDialog()
    },
    base64ToBlob(base64, mimeType) {
      const binary = atob(base64)
      const len = binary.length
      const buffer = new Uint8Array(len)
      for (let i = 0; i < len; i++) {
        buffer[i] = binary.charCodeAt(i)
      }
      return new Blob([buffer], { type: mimeType })
    },
    blobToFile(blob, filename) {
      return new File([blob], filename, { type: blob.type })
    }
  }
}
</script>

<style lang="less" scoped>
.screenshot-box {
  display: flex;
  justify-content: center;
  padding-bottom: 16px;

  .tip-box {
    display: flex;
    border: 1px dashed #ffffff;
    height: 128px;
    width: 208px;

    .text-box {
      margin: auto 10px;
      color: var(--page-tips-text-color);
      font-size: 14px;
    }
  }

  img {
    width: 208px;
    height: 128px;
    object-fit: cover;
  }
}

.common-button-box {
  text-align: center;
  justify-content: center;
  padding-top: 16px;
  margin: 0 -16px;
  border-top: 1px solid var(--dialog-footer-border-color);
}
</style>
